import { defineMessages } from "react-intl";

export const imagePreviewerMessages = defineMessages({
  imageLoadFailed: {
    id: "imagePreviewer.imageLoadFailed",
    defaultMessage: "Failed to load image",
  },
  previousImage: {
    id: "imagePreviewer.previousImage",
    defaultMessage: "Previous image",
  },
  nextImage: {
    id: "imagePreviewer.nextImage",
    defaultMessage: "Next image",
  },
});
